import { render, staticRenderFns } from "./QuotationPriceHistoryInfo.vue?vue&type=template&id=cd82803c&"
import script from "./QuotationPriceHistoryInfo.vue?vue&type=script&lang=js&"
export * from "./QuotationPriceHistoryInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports